import Loading from './Loading';
import React from 'react';

export function LoadingWithError(props) {
  if (props.error) {
    if (process.env.NODE_ENV === 'development') {
      /* eslint-disable */
      console.error(props.error);
    }
    throw new Error(props.error);
  } else {
    return <Loading {...props} />;
  }
}
